/* eslint-disable */
export const minusIcon = {
  data: `<svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.9527 12.9407H1.04781" stroke="currentColor" stroke-width="1.93614" stroke-linecap="round"/></svg>`,
  name: 'minus' as const,
};
